import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { getNestedVal, isObjEmptyOrNull } from '../UtilityFunctions';
import useLoanSearch, { LoanServicingSearchReq } from './useLoanSearch';

export function useLoanSearchQuery(initialLoanParams: LoanServicingSearchReq = null) {
  const { loanSearchInfo, searchLoans, statuses, handleChange } = useLoanSearch();
  const { data, isLoading, isFetching } = useQuery({
    queryKey: ['loanSearch', loanSearchInfo],
    queryFn: async ({ signal }: { signal: AbortSignal }) => {
      const response = await searchLoans();
      return { data: response };
    },
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (!isObjEmptyOrNull(initialLoanParams)) {
      for (const key in initialLoanParams) {
        if (loanSearchInfo && getNestedVal(loanSearchInfo, key) != initialLoanParams[key]) {
          handleChange('edit', key, initialLoanParams[key]);
        }
      }
    }
  }, [initialLoanParams]);

  const noDuplicateLoans = [...new Map(data?.data.map((item) => [item.loanNo, item])).values()];

  return {
    loans: noDuplicateLoans,
    loading: isLoading || isFetching,
    errors: statuses.errors,
  };
}
